import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import type { InviteOwedBreakdownResponse } from '@/api/types';

/**
 * Fetch the owed breakdown for an invite. Portal-safe shape (createdBy and
 * raw source refs are redacted server-side). `enabled` gate lets callers
 * fetch only when the collapsible is actually opened — the common
 * paid-in-full case stays single-request.
 */
export function useInviteOwedBreakdown(
  publicId: string | undefined,
  { enabled }: { enabled: boolean },
) {
  const api = useApi();
  return useQuery({
    enabled: Boolean(publicId) && enabled,
    queryKey: ['invite-owed-breakdown', publicId],
    queryFn: () =>
      api.get<InviteOwedBreakdownResponse>(`/portal/invites/${publicId}/breakdown`),
    staleTime: 30_000,
  });
}
